var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10060",
    "data-name": "Group 10060",
    transform: "translate(-960 -577)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_572",
    "data-name": "Ellipse 572",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(960 577)",
    fill: "#002147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sound-volume-2-svgrepo-com",
    transform: "translate(972.051 589.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7961",
    "data-name": "Path 7961",
    d: "M15.175,4.519c-1.508-.564-4.709,1.226-7.358,3.568H5.855A4.905,4.905,0,0,0,.949,12.993v2.453a4.905,4.905,0,0,0,4.905,4.905H7.817c2.588,2.379,5.788,4.133,7.358,3.581,2.575-.957,3-6.132,3-9.712S17.75,5.476,15.175,4.519Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7962",
    "data-name": "Path 7962",
    d: "M20.66,6.72a9.811,9.811,0,0,1,0,13.87",
    transform: "translate(4.461 0.522)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7963",
    "data-name": "Path 7963",
    d: "M18.539,17.55a6.132,6.132,0,0,0,0-8.67",
    transform: "translate(3.981 1.011)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerUnchecked);
export default __webpack_public_path__ + "static/media/speaker-unchecked.70b2dfd1d1b7c5f02f0ec5bca016e120.svg";
export { ForwardRef as ReactComponent };